import { Rating, RatingProps } from '@smastrom/react-rating';

import '@smastrom/react-rating/style.css';

const StarDrawing = (
  <path
    d='M6.10864 2.25278C6.47934 1.52384 7.52066 1.52384 7.89136 2.25278L8.77268 3.98581C8.92049 4.27647 9.20073 4.4768 9.52358 4.5226L11.4458 4.79532C12.275 4.91296 12.6009 5.93673 11.9924 6.51207L10.6415 7.78918C10.3971 8.02023 10.28523 8.35866 10.34375 8.68985L10.6675 10.5222C10.8112 11.3352 9.96347 11.9622 9.22813 11.5869L7.45464 10.6816C7.16907 10.5358 6.83093 10.5358 6.54536 10.6816L4.77186 11.5869C4.03653 11.9622 3.18882 11.3352 3.33248 10.5222L3.65625 8.68985C3.71477 8.35866 3.60289 8.02023 3.3585 7.78918L2.00763 6.51207C1.39907 5.93673 1.72499 4.91296 2.55416 4.79532L4.47643 4.5226C4.79927 4.4768 5.07951 4.27647 5.22732 3.98581L6.10864 2.25278Z'
    stroke='#FF9606'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='0.4'
  />
);

const customStyles = {
  itemShapes: StarDrawing,
  activeFillColor: '#FF9606',
  inactiveFillColor: '#FFFFFF',
};
export default function Rate({ ...props }: RatingProps) {
  return <Rating {...props} itemStyles={customStyles} />;
}
